import { RootStore } from './root.store';
import { makeAutoObservable } from 'mobx';
import { CreditCardType, IPaymentInformation, PaymentOption } from '../domains/payment-information.domain';
import { ErrorType } from '../domains/common.domain';

export class PaymentInformationStore {
  root: RootStore;
  private _information: IPaymentInformation = {
    paymentOption: { value: '', errorType: 'required' },
    creditCardType: { value: '', errorType: 'required' },
    creditCardToken: { value: '', errorType: 'required' },
    creditCardNumber: { value: '', errorType: 'required' },
    creditCardHolderName: { value: '', errorType: 'required' },
    debitCardBankName: { value: '', errorType: 'required' },
    debitCardAccountCode: { value: '', errorType: 'required' },
  };

  constructor(root: RootStore) {
    makeAutoObservable(this);
    this.root = root;
  }

  get information(): IPaymentInformation {
    return this._information;
  }

  updateInformation(field: keyof IPaymentInformation, value: string) {
    const errorType = !value ? 'required' : undefined;
    if (field === 'paymentOption') {
      this._information[field] = {
        value: value as PaymentOption,
        errorType,
      };
      return;
    }
    if (field === 'creditCardType') {
      this._information[field] = {
        value: value as CreditCardType,
        errorType,
      };
      return;
    }
    this._information[field] = {
      value: value,
      errorType,
    };
  }

  setError(field: keyof IPaymentInformation, error: ErrorType | undefined) {
    this._information[field].errorType = error;
  }

  get isFormValid(): boolean {
    if (this._information.paymentOption.value === 'Credit Card') {
      return (
        !this._information.creditCardType.errorType &&
        !this._information.creditCardToken.errorType &&
        !this._information.creditCardHolderName.errorType
      );
    }
    if (this._information.paymentOption.value === 'Debit') {
      return !this._information.debitCardAccountCode.errorType && !this._information.debitCardBankName.errorType;
    }
    return !!this._information.paymentOption.value;
  }
}
